import { server } from "../config/constants";

const request = async (path, { token, method = "GET", body, signal } = {}) => {
  const response = await fetch(`${server}${path}`, {
    method,
    signal,
    headers: {
      Accept: "application/json",
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });

  let payload = null;

  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    const message =
      payload?.messages?.[0] ||
      payload?.message ||
      `Error HTTP ${response.status}`;

    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return payload;
};

const requestBlob = async (
  path,
  { token, method = "GET", body, signal } = {}
) => {
  const response = await fetch(`${server}${path}`, {
    method,
    signal,
    headers: {
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });

  if (!response.ok) {
    let payload = null;

    try {
      payload = await response.json();
    } catch {
      payload = null;
    }

    throw new Error(
      payload?.messages?.[0] ||
        payload?.message ||
        `Error HTTP ${response.status}`
    );
  }

  const disposition = response.headers.get("Content-Disposition") || "";
  const filenameMatch = disposition.match(/filename="?([^"]+)"?/i);

  return {
    blob: await response.blob(),
    filename: filenameMatch?.[1] || "exportacion.xlsx",
  };
};

export const dashboardService = {
  list: ({ token, signal } = {}) =>
    request("dashboards", { token, signal }),

  getVersion: (dashboardId, { token, signal } = {}) =>
    request(`dashboards/${dashboardId}/version`, { token, signal }),

  getGrafanaAuth: (dashboardId, { token, signal } = {}) =>
    request(`dashboards/${dashboardId}/grafana-auth`, { token, signal }),

  getLayout: (dashboardId, { token, signal } = {}) =>
    request(`dashboards/${dashboardId}/layout`, { token, signal }),

  getVariables: (id, { token, signal } = {}) =>
    request(`dashboards-configuraciones/${id}/variables`, { token, signal }),

  exportPanel: (id, panelId, values, { token, signal } = {}) =>
    requestBlob(
      `dashboards-configuraciones/${id}/panels/${panelId}/export`,
      {
        token,
        signal,
        method: "POST",
        body: {
          values,
          timezone:
            Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC",
        },
      }
    ),

  // Optional hierarchical endpoint. Existing getVariableOptions remains the default.
  getVariableOptionsBatch: (id, variables, values, { token, signal } = {}) =>
    request(`dashboards-configuraciones/${id}/variables/opciones`, {
      token,
      signal,
      method: "POST",
      body: { variables, values },
    }),

  getVariableOptions: (id, variable, values, { token, signal } = {}) =>
    request(
      `dashboards-configuraciones/${id}/variables/${encodeURIComponent(variable)}/opciones`,
      {
        token,
        signal,
        method: "POST",
        body: { values },
      }
    ),
};
